<template>
  <div>
    <SlideShowSection />
    <EnrollmentSection />
    <CoursesSection />
    <CalendarSection />
    <ArticlesSection />
    <GalleriesSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import CoursesSection from "../components/sections/CoursesSection.vue";
import ArticlesSection from "../components/sections/ArticlesSection.vue";
import GalleriesSection from "../components/sections/GalleriesSection.vue";
import EnrollmentSection from "../components/sections/EnrollmentSection.vue";
import CalendarSection from "../components/sections/CalendarSection.vue";

export default {
  components: {
    SlideShowSection,
    CoursesSection,
    ArticlesSection,
    GalleriesSection,
    EnrollmentSection,
    CalendarSection,
  },
};
</script>
